import { LAYOUTS, POSITION, } from '@voltmoney/types';
import { WIDGET } from "@voltmoney/schema";
import { ROUTE } from '../../../routes';
import { ACTION } from './types';
import { contact, faqDetails, goBack } from './actions';
import SharedPropsService from '../../../SharedPropsService';
import { shouldShowVoltContactUs } from '../../../configs/uri-config-utils';
import { Platform } from "react-native";
import sharedPropsService from "../../../SharedPropsService";
import { getTenure } from "./utils";
import { LENDER_ID } from "../../../configs/constants";
export const template = (showContactUs, tenure, lenderId, height) => {
    return {
        layout: {
            id: ROUTE.FAQ,
            type: LAYOUTS.LIST,
            style: {
                isFromPartnerPlatform: true
            },
            widgets: [
                Platform.OS === "ios" ? { id: "spaceXXL", type: WIDGET.SPACE, position: POSITION.ABSOLUTE_TOP } : {},
                { id: "faqSectionPageDC", type: WIDGET.FAQ_SECTION_PAGE },
            ],
        },
        datastore: {
            faqSectionPageDC: {
                height: height,
                goBackAction: {
                    type: ACTION.BACK_BUTTON,
                    payload: {
                        value: '',
                        widgetId: 'continue',
                        isResend: false,
                    },
                    routeId: ROUTE.FAQ,
                },
                needHelpAction: {
                    type: ACTION.CONTACT,
                    payload: {
                        value: '',
                        widgetId: 'continue',
                        isResend: false,
                    },
                    routeId: ROUTE.FAQ,
                },
                showContactUs: showContactUs,
                tenure: tenure,
                lenderId: lenderId
            }
        },
    };
};
export const faqMF = {
    onLoad: async ({ getHeight }) => {
        const userData = await SharedPropsService.getUser();
        const loan_tenure_BAJAJ = await sharedPropsService.getFirebaseConfig()?.loan_tenure_BAJAJ;
        const loan_tenure_TATA = await sharedPropsService.getFirebaseConfig()?.loan_tenure_TATA;
        const isFromTata = userData.linkedApplications[0].lenderAccountId.toLowerCase() === LENDER_ID.TATA.toLowerCase();
        let tenure;
        tenure = isFromTata ?
            getTenure(loan_tenure_TATA) :
            getTenure(loan_tenure_BAJAJ);
        const showContactUs = shouldShowVoltContactUs(await SharedPropsService.getURL());
        const lenderId = userData.linkedApplications[0].lenderAccountId.toLowerCase();
        return Promise.resolve(template(showContactUs, tenure, lenderId, getHeight()));
    },
    actions: {
        [ACTION.FAQ]: faqDetails,
        [ACTION.CONTACT]: contact,
        [ACTION.BACK_BUTTON]: goBack,
    },
    bgColor: '#FFFFFF',
};
